module.exports.showCover = ->
  @model.getBoard().getPref('cardCovers') && @model.hasCover() && !@onCalendar
